import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { deleteuser, getUsersList } from 'app/api/users';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
const useUserManagement = () => {
  const [isdeleteFiltering, setIsdeleteFiltering] = useState(false);
  const navigate = useNavigate();
  const sectionObj = {
    sectionTitle: 'User Management',
    searchObj: {
      keys: ['name', 'phone'],
      placeholder: 'Search by Name, Contact No.',
      searchType: 'server',
      handleSearch: (e) => {
        console.log('Handle search: ', e);
      },
    },
    buttons: [
      {
        customclassName: '',
        imgTrue: true,
        title: APP_CONSTANTS.CREATE_USER_TAG,
        handleBtnClick: (e) => {
          navigate(`${APP_CONSTANTS.CREATE_USER}`);
        },
      },
    ],
  };

  const [pageCount, setPageCount] = useState(1);
  const [pageLoading, setPageLoading] = useState(false);
  const currentPage = 1;
  const dataPerPage = 10;
  const [filteredData, setFilteredData] = useState([]);
  const [totalNumber, setTotalNumber] = useState(0);
  const fetchBillData = useCallback(
    async (page, searchValue = '') => {
      setPageLoading(true);
      try {
        const response = await getUsersList({
          page,
          limit: dataPerPage,
          search: searchValue,
        });
        if (response?.responseCode === 200) {
          const dataArr = response?.data?.usersList || [];
          const newArray = dataArr.map((item) => ({
            ...item,
          }));
          setFilteredData(newArray);
          const totalCount = response?.data?.count || 0;
          const tempcount = Math.ceil(totalCount / dataPerPage);
          setTotalNumber(totalCount);
          setPageCount(tempcount);
          setIsdeleteFiltering(false);
        } else {
          Toast.error(
            response?.response?.message || Message.Error.COMMON_MESSAGE
          );
        }
      } catch (error) {
        Toast.error(Message.Error.COMMON_MESSAGE);
      } finally {
        setPageLoading(false);
      }
    },
    [dataPerPage]
  );

  async function calldeleteUser(data) {
    setPageLoading(true);
    if (data && data?.id) {
      let responseObj = await deleteuser(data?.id);
      setPageLoading(false);
      setIsdeleteFiltering(true);
      if (responseObj?.responseCode === 200) {
        Toast.success('User Deleted Successfully');
      }
    } else {
      Toast.error('Failed to delete');
    }
  }

  function handleDelete(data) {
    confirmAlert({
      title: '',
      message: `Are you sure you want to Delete ${data?.name} this user?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            calldeleteUser(data);
          },
        },
        {
          label: 'No',
        },
      ],
      overlayClassName: 'overlay-custom-class-name',
    });
  }
  function handleEdit(data) {
    navigate(`/user/edit/:${data.id}`, {
      state: {
        ...data,
      },
    });
  }

  return {
    totalNumber,
    filteredData,
    sectionObj,
    handleDelete,
    handleEdit,
    pageLoading,
    currentPage,
    dataPerPage,
    pageCount,
    navigate,
    fetchBillData,
    isdeleteFiltering,
  };
};

export default useUserManagement;
